import useRetrieveData from 'global/hooks/useRetrieveData';
import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';
import { uniqBy } from 'lodash';

export const useVendors = (realmId, opts = {}) => {
  opts = {
    include: 'realms,client,vendor,editions,scorecards',
    includeBuilders: false,
    ...opts,
  };

  const meRealm = useSelector((state) => get(state, 'auth.user.realm'));
  const realm_id = realmId || get(meRealm, 'id');

  const builders = useRetrieveData({ url: '/realms' }, {
    build: ['realms'],
    useCache: { reload: 20 },
    params: {
      directRelate: 1,
      filter: {
        tier: 'builder'
      }
    },
  })

  const resp = useRetrieveData(
    { url: `/client-vendors` },
    {
      build: ['clientVendors'],
      useCache: { reload: 20 },
      params: { include: opts.include },
      ...opts,
    }
  );

  const data = (() => {
    let rs = [opts.includeUsersRealm ? { id: -1, vendorId: get(meRealm, 'id'), clientId: -1, vendor: meRealm } : null, ...(resp.data || []).filter((v) => `${v.vendorId}` !== `${realm_id}`)];

    if (opts.includeBuilders) {
      rs = [...rs, ...builders.data.map((b, i) => { 
        return {
          ...b, 
          id: b.id,
          vendorId: `${get(b, 'id')}`, 
          vendor: b,
        }
      })].map(v => ({ ...v, vendorId: `${v.vendorId}` }));
    }
    
    return uniqBy(rs, 'vendorId').filter(f => f);
  })()

  return {
    ...resp,
    data,
  };
};

export const useClients = (realmId, user_id, opts = {}) => {
  opts = {
    include: 'realms,client,vendor,editions,scorecards',
    ...opts,
  };

  const meRealmId = useSelector((state) => get(state, 'auth.user.realm.id'));
  const realm_id = realmId || meRealmId;
  return useRetrieveData(
    { url: `/client-vendors` },
    {
      useEffect: true,
      build: ['clientVendors'],
      useCache: { reload: 20 },
      params: {
        include: opts.include,
        filter: { vendor_id: realm_id, user_id },
      },
      ...opts,
    }
  );
};
